import React from "react";
import { isEmpty } from "bodycodi/cmap/app/js/common";

import coach_default from "bodycodi/cmap/app/svg/default_profile.svg";

type Image = {
  src: string;
  className?: string;
};

const Image = ({ src, className }: Image) => {
  return <img src={isEmpty(src) ? coach_default : src} className={className} />;
};

export default Image;
